module.exports = __webpack_public_path__ + "res/7-img_reward_t.724e723c4ea5d2ba30b6046741a136fa.png";